















































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import SpesimenLabInputModal from "@/components/modal/SpesimenLabInputModal.vue";
import SpesimenLabSvc from "@/services/SpesimenLab";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { isLaboratorium } from "@/utils/unit";
import { tampilWaktu, WARNA_STATUS_SPESIMEN } from "@/utils/spesimenLab";
import {
  SpesimenLab,
  SpesimenLabFhirResponse,
  SpesimenLabKonteks,
  SpesimenLabPermintaan,
  SpesimenLabReferensi
} from "@/types/spesimen_lab";

@Component({
  components: {
    ConfirmDialog,
    SpesimenLabInputModal
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardSpesimenLab extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  items: SpesimenLab[] = [];
  konteks: SpesimenLabKonteks | null = null;
  permintaan: SpesimenLabPermintaan[] = [];
  referensi: SpesimenLabReferensi | null = null;
  loading = false;
  gagal = false;

  modalInput = false;
  editData: SpesimenLab | null = null;

  modalHapus = false;
  hapusTarget: SpesimenLab | null = null;
  menghapus = false;

  modalFhir = false;
  fhirTarget: SpesimenLab | null = null;
  fhir: SpesimenLabFhirResponse | null = null;
  fhirLoading = false;

  warnaStatus = WARNA_STATUS_SPESIMEN;
  tampilWaktu = tampilWaktu;

  private nomorMuat = 0;
  private nomorFhir = 0;

  get unitLab(): boolean {
    const user: any = userModule.user;
    return isLaboratorium(user ? user.unit_id : null);
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get bisaInput(): boolean {
    return this.unitLab && !this.readOnly;
  }

  get alasanTerkunci(): string {
    if (!this.unitLab) {
      return "Input dan perubahan data spesimen hanya untuk petugas Unit Laboratorium. Unit Anda hanya dapat melihat data.";
    }
    if (this.readOnly) {
      return "Kunjungan ini sudah terkunci (lebih dari 48 jam setelah pasien pulang). Ajukan akses revisi untuk menambah atau mengubah data spesimen.";
    }
    return "";
  }

  get fhirJson(): string {
    return this.fhir ? JSON.stringify(this.fhir.resource, null, 2) : "";
  }

  @Watch("register", { immediate: true })
  onRegisterChange() {
    this.items = [];
    this.konteks = null;
    this.permintaan = [];
    this.modalInput = false;
    this.modalFhir = false;
    this.muat();
  }

  async muat() {
    if (!this.register) {
      return;
    }

    const nomor = ++this.nomorMuat;
    this.loading = true;
    this.gagal = false;

    try {
      const hasil = await SpesimenLabSvc.getByRegister(this.register);
      if (nomor !== this.nomorMuat) {
        return;
      }
      this.items = Array.isArray(hasil.data) ? hasil.data : [];
      this.konteks = hasil.konteks || null;
      this.permintaan = Array.isArray(hasil.permintaan) ? hasil.permintaan : [];
      this.referensi = hasil.referensi || null;
    } catch (e) {
      if (nomor === this.nomorMuat) {
        this.gagal = true;
      }
    } finally {
      if (nomor === this.nomorMuat) {
        this.loading = false;
      }
    }
  }

  buka(item: SpesimenLab | null) {
    if (!this.bisaInput) {
      return;
    }
    this.editData = item;
    this.modalInput = true;
  }

  konfirmasiHapus(item: SpesimenLab) {
    this.hapusTarget = item;
    this.modalHapus = true;
  }

  async hapus() {
    if (!this.hapusTarget || this.menghapus || !this.bisaInput) {
      return;
    }
    this.menghapus = true;
    try {
      await SpesimenLabSvc.destroy(this.hapusTarget.id);
      appModule.NoticeDelay("Data spesimen dihapus");
      this.muat();
    } catch (e) {
      return;
    } finally {
      this.menghapus = false;
      this.hapusTarget = null;
    }
  }

  async lihatFhir(item: SpesimenLab) {
    const nomor = ++this.nomorFhir;
    this.fhirTarget = item;
    this.fhir = null;
    this.fhirLoading = true;
    this.modalFhir = true;

    try {
      const hasil = await SpesimenLabSvc.fhir(item.id);
      if (nomor === this.nomorFhir) {
        this.fhir = hasil;
      }
    } catch (e) {
      if (nomor === this.nomorFhir) {
        this.modalFhir = false;
      }
    } finally {
      if (nomor === this.nomorFhir) {
        this.fhirLoading = false;
      }
    }
  }

  async salinFhir() {
    if (!this.fhirJson) {
      return;
    }
    try {
      await navigator.clipboard.writeText(this.fhirJson);
      appModule.NoticeDelay("JSON FHIR disalin");
    } catch (e) {
      appModule.sendErrorAlert("Gagal menyalin JSON ke clipboard");
    }
  }
}
